import {Ref, ref} from 'vue';

export function useOnOff(isOn: boolean) {
    const refValue = ref(isOn);

    const on = () => {
        refValue.value = true;
    };

    const off = () => {
        refValue.value = false;
    };

    return [refValue, on, off] as [Ref<boolean>, typeof on, typeof off];
}
